module.exports = __webpack_public_path__ + "static/media/Debby.62f94c53.png";